import { defineMessages } from 'react-intl';

/**
 * Copy for the MCP Bitbucket workspace picker.
 *
 * `placeholder` keeps the `.placeholder.workspace` id it was suffixed with back
 * when this screen ran alongside a second MCP implementation, rather than the
 * shorter `.placeholder`, so existing extractions and translations keep
 * resolving.
 */
export const bitbucketWorkspaceSelectorMessages = defineMessages({
  label: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.label',
    defaultMessage: 'Bitbucket workspace',
    description: 'Label above the Bitbucket workspace picker',
  },
  placeholder: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.placeholder.workspace',
    defaultMessage: 'Select',
    description: 'Placeholder text inside the Bitbucket workspace picker',
  },
  noPermissions: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.noPermissions',
    defaultMessage:
      'No permissions are available for the selected workspace. Select a different workspace to continue.',
    description:
      'Message below the Bitbucket workspace picker when the permission check succeeded but returned no permissions',
  },
  orgConstraint: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.orgConstraint',
    defaultMessage:
      'Only workspaces from the same organization as the site can be selected',
    description:
      'Helper below the Bitbucket workspace picker when a site is already selected, so other-org workspaces are listed but disabled',
  },
  noOrgWorkspaces: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.noOrgWorkspaces',
    defaultMessage:
      'No workspaces from the same organization as the selected site are available',
    description:
      'Helper below the Bitbucket workspace picker when a site is selected and every listed workspace is in a different organization',
  },
});
